import { useState } from 'react';

import { StyledBox } from 'pages/Roles/RolesCreate/RolesCreate.styled';
import { Box } from 'shared/mui/Box';

const DEFAULT_ICON = '/default.svg';

type RolesFormDirectionProps = {
  description?: string;
  value?: string;
};

export const RolesFormDirection: React.FC<RolesFormDirectionProps> = ({ description, value }) => {
  const [src, setSrc] = useState(description || DEFAULT_ICON);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {(description || value) && (
        <img
          alt="icon"
          onError={() => setSrc(DEFAULT_ICON)}
          src={src}
          style={{ height: '22px', width: '22px' }}
        />
      )}
      {value && <StyledBox>{value}</StyledBox>}
    </Box>
  );
};
